module.exports = __webpack_public_path__ + "media/containers/InvestmentCalculationPDF/Images/SmartInvest-1c9bf7b0eeccc13009441d102b3aa9a4.png";